import ContainedButton from 'components/layout/form/containedButton';
import OutlinedButton from 'components/layout/form/outlinedButton';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 24px 140px;

  @media (max-width: 768px) {
    padding: 16px 14px 140px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderText = styled.div``;

export const Title = styled.h1`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 24px;
  line-height: 37px;
  color: #0b29fb;
  margin: unset;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const SubTitle = styled.h2`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  margin: unset;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const StepsWrapper = styled.div`
  margin-top: 24px;
`;

export const ContainerWrap = styled.div`
  width: 100%;
  min-height: 529px;
  margin-top: 24px;
`;

export const ControlsWrap = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
`;

export const ButtonCancel = styled(OutlinedButton)`
  width: 193px;
  height: 40px;

  &:disabled {
    background: transparent;
    border-color: #0000ff;
    color: #0000ff;
    filter: opacity(0.4);
    cursor: not-allowed;
  }
`;

export const ButtonConfirm = styled(ContainedButton)`
  width: 193px;
  height: 40px;
`;

export const ModalStyled = styled(Modal)`
  & .modal-dialog {
    max-width: 550px;
    width: 100%;
  }

  & .modal-content {
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 25px 40px;
    width: 100%;

    @media (max-width: 768px) {
      padding: 25px;
    }
  }
`;

export const StepsMobileWrapper = styled.div``;

export const ContainerBasesWrapper = styled.div``;

export const BasesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  max-height: 300px;
  overflow: auto;
  max-width: 100vw;
  overflow: scroll;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
